<span #ancora
      class="desenhos-texto"
      [class.com-tooltip]="temTooltip"
      [attr.tabindex]="temTooltip ? 0 : null"
      [attr.aria-label]="temTooltip ? 'Desenhos do produto: ' + texto : null"
      (mouseenter)="agendarAbrir()"
      (mouseleave)="agendarFechar()"
      (focus)="agendarAbrir()"
      (blur)="agendarFechar()">{{ texto }}</span>

<!-- Movido para o <body> ao abrir (ver DesenhosProdutoComponent). -->
<div #cartao
     *ngIf="aberto"
     class="desenhos-popover"
     role="tooltip"
     (mouseenter)="cancelarFechar()"
     (mouseleave)="agendarFechar()">
  <div class="popover-cabecalho">
    <i class='bx bx-sketch icone-cabecalho'></i>
    <span class="titulo">Desenhos do produto</span>
    <span class="contador">{{ lista.length }}</span>
  </div>

  <ul class="lista-desenhos">
    <li *ngFor="let d of lista; trackBy: trackByDesenho" class="desenho">
      <div class="linha-principal">
        <span class="numero">{{ d.numeroDesenho }}</span>
        <span *ngIf="d.padrao" class="pilula-padrao"><i class='bx bxs-star'></i>Padrão</span>
      </div>
      <div *ngIf="d.versao && d.versao !== '0'" class="detalhe"><span class="rotulo">Versão</span> {{ d.versao }}</div>
      <div *ngIf="d.observacao" class="observacao">{{ d.observacao }}</div>
    </li>
  </ul>
</div>
